var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vcode-timer-btn",class:[_vm.canHandle ? 'allow' : 'disabled'],on:{"click":_vm.onClick}},[(!_vm.isReqSending)?_c('div',{staticClass:"btn-txt"},[_vm._v(_vm._s(_vm.btnText))]):_c('div',{staticClass:"btn-loading"},[_c('img',{staticClass:"loading-icon",attrs:{"src":require("@/assets/loading_small.webp")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }